import React, {PureComponent} from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import {connect} from 'react-redux';

import styles from './spinner.less';
import appStyles from '../../styles/styles.less';

/**
 * react port of AUI-Spinner
 * see https://docs.atlassian.com/aui/latest/docs/spinner.html
 */
export class Spinner extends PureComponent {
    static propTypes = {
        checksComplete: PropTypes.bool,
    };

    static defaultProps = {
        checksComplete: false,
    };

    static contextTypes = {
        i18n: PropTypes.func,
    };

    render() {
        if (this.props.checksComplete) {
            return null;
        }

        return (
            <div className={appStyles.checkProgress}>
                <h4 className={appStyles.checkProgressTitle}>{this.context.i18n('johnson.page.progress')}</h4>
                <div>
                    <div className={styles.spinner} role="progressbar">
                        <div className={classnames(styles.spinnerHandWrapper, styles.spinnerHandWrapper1)}>
                            <div className={styles.spinnerHand} />
                        </div>
                        <div className={classnames(styles.spinnerHandWrapper, styles.spinnerHandWrapper2)}>
                            <div className={styles.spinnerHand} />
                        </div>
                        <div className={classnames(styles.spinnerHandWrapper, styles.spinnerHandWrapper3)}>
                            <div className={styles.spinnerHand} />
                        </div>
                        <div className={classnames(styles.spinnerHandWrapper, styles.spinnerHandWrapper4)}>
                            <div className={styles.spinnerHand} />
                        </div>
                        <div className={classnames(styles.spinnerHandWrapper, styles.spinnerHandWrapper5)}>
                            <div className={styles.spinnerHand} />
                        </div>
                        <div className={classnames(styles.spinnerHandWrapper, styles.spinnerHandWrapper6)}>
                            <div className={styles.spinnerHand} />
                        </div>
                        <div className={classnames(styles.spinnerHandWrapper, styles.spinnerHandWrapper7)}>
                            <div className={styles.spinnerHand} />
                        </div>
                        <div className={classnames(styles.spinnerHandWrapper, styles.spinnerHandWrapper8)}>
                            <div className={styles.spinnerHand} />
                        </div>
                        <div className={classnames(styles.spinnerHandWrapper, styles.spinnerHandWrapper9)}>
                            <div className={styles.spinnerHand} />
                        </div>
                        <div className={classnames(styles.spinnerHandWrapper, styles.spinnerHandWrapper10)}>
                            <div className={styles.spinnerHand} />
                        </div>
                        <div className={classnames(styles.spinnerHandWrapper, styles.spinnerHandWrapper11)}>
                            <div className={styles.spinnerHand} />
                        </div>
                        <div className={classnames(styles.spinnerHandWrapper, styles.spinnerHandWrapper12)}>
                            <div className={styles.spinnerHand} />
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

const mapStateToProps = state => ({
    checksComplete: state.events.checksComplete,
});

export default connect(mapStateToProps)(Spinner);



// WEBPACK FOOTER //
// ./src/components/Spinner/Spinner.js